import React, { Component } from "react";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import TimelineIcon from "@material-ui/icons/Timeline";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import "./BottomMenu.css";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import { push } from "react-router-redux";
import { connect } from "react-redux";

class BottomMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };
  render() {
    const { history } = this.props;
    return (
      <div className="Nav-btn">
        <div className="AppBar">
          <div className="menu-item">
            <HomeOutlinedIcon
              onClick={() => {
                history.push("/withdrawal");
              }}
              className="icon-item"
            />
            <p>Home</p>
          </div>

          <div className="menu-item">
            <TimelineIcon
              onClick={() => {
                history.push("/history");
              }}
              className="icon-item"
            />

            <p>Hitorial</p>
          </div>
          <div className="menu-item">
            <WhatshotIcon
              onClick={() => {
                history.push("/benefits");
              }}
              className="icon-benefit"
            />
            <p>Beneficios</p>
          </div>

          <div className="menu-item">
            <CreditCardIcon
              onClick={() => {
                history.push("/coach");
              }}
              className="icon-item"
            />
            <p>Coach</p>
          </div>

          <div className="menu-item">
            <ChatBubbleOutlineIcon
              onClick={() => {
                history.push("/support");
              }}
              className="icon-item"
            />
            <p>Soporte</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
  push: route => dispatch(push(route))
});

export default connect(mapStateToProps, mapDispatchToProps)(BottomMenu);
